import _ from 'lodash';

const TYPE_KEY = '_WWEdH6pkj_';

export default (items, keyOrClause, options) => {
  _.defaults();

  let clause = keyOrClause;
  if (_.isString(clause)) {
    clause = clause.split(',').reduce((acc, value) => {
      acc[_.trim(value)] = 'asc';
      return acc;
    }, {});
  }

  if (_.get(options, 'mongoDbCompatible')) {
    clause = { [TYPE_KEY]: _.values(clause)[0], ...clause };
  }

  const keys = _.keys(clause);
  return _.orderBy(
    items,
    _.map(keys, key => v => {
      if (key === TYPE_KEY) {
        return _.isNil(_.get(v, keys[1])) ? 0 : 1;
      }

      const value = _.get(v, key);

      if (!_.isString(value)) {
        // null et undefined ne doivent pas être traités différemment.
        return _.isNull(value) ? undefined : value;
      }

      return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    }),
    _.map(keys, k => _.toLower(clause[k]))
  );
};
